export default {
  navigationBarTitleText: '我的投稿'
};
